module.exports = {
  eventCategory: 'Editor UI | Tool Menu | KWLS',

  show: { eventAction: 'show' }
};
